export default "__VITE_ASSET__CbiCOpwO__"